(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/7/8
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('roomDetail', {
                parent: 'module',
                url: '/room-detail?:id',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/room/room-detail.html',
                        controller: 'RoomDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
